import { defineStore } from 'pinia';

import ProductRoutes from '@/router/routeNames';
import CommonInterface from '../../interface/data/common.js';
import DataService from '../services/DataService.js';
import { Logger } from '../middlewares/sentry.js';
import { useEventStore } from '@/stores/event/event.store';
import { useRsvpStore } from './rsvp/rsvp.store';

export const useStateStore = defineStore('coreState', {
  state: () => ({
    isBlackTheme: localStorage.getItem('isBlackTheme') === 'true',

    clientId: '',
    colors: {
      mainColor: '#000',
      buttonColor: '#000',
      backgroundColor: '#f8f1e8',
    },
    clientData: {
      common: {
        eventDate: '',
        eventsType: [],
        defaultType: ProductRoutes.unknow,
        langList: ['pl'],
        isNewSender: true,
      },
    },
    isDataReceived: false,
    isButtonsDisabled: false,
  }),
  actions: {
    setColors(mainColor, buttonColor, backgroundColor) {
      this.colors = {
        mainColor,
        buttonColor,
        backgroundColor,
      };
    },
    async trySetupData(clientId) {
      await this._setClientId(clientId);
    },
    async tryGetLangDataWithImages(_lang) {},
    async _setClientId(clientId) {
      this.clientId = clientId;

      if (!this.isDataReceived) {
        await this._tryGetClientData();
        this.isDataReceived = true;
      } else {
        new Promise(async () => {
          this._tryGetClientData();
        });
      }
    },
    async _tryGetClientData() {
      try {
        const data = await DataService.getCommonData();
        this.clientData.common = new CommonInterface(data);
      } catch (err) {
        Logger.error(err);
        this.clientData.common = new CommonInterface({});
      }
    },
    isRsvpActive() {
      const date = new Date(this.eventDate);
      const currentDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
      if (this.eventsType.includes(ProductRoutes.rsvp) && date > currentDate) {
        return true;
      } else {
        return false;
      }
    },
    enableGallery() {
      this.clientData.common.eventsType.push(ProductRoutes.gallery);
    },
    disableGallery() {
      this.clientData.common.eventsType =
        this.clientData.common.eventsType.filter(
          (i) => i !== ProductRoutes.gallery,
        );
    },
    disableButtons() {
      this.isButtonsDisabled = true;
    },
    resetData() {
      useEventStore().resetData();
      useRsvpStore().resetData();

      this.clientId = '';
      this.clientData.common = {
        eventDate: '',
        eventsType: [],
        defaultType: ProductRoutes.unknow,
        langList: ['pl'],
        isNewSender: true,
      };
    },
  },
  getters: {
    getClientId: (state) => state.clientId,
    getCommonData: (state) => state.clientData.common,
    getEventsType: (state) => state.clientData.common.eventsType,
    isAllButtonsDisabled: (state) => {
      return state.isButtonsDisabled;
    },
    isGallery: (state) => {
      return state.clientData.common.eventsType.includes(ProductRoutes.gallery);
    },
    isVideoGallery: (state) => {
      return state.clientData.common.eventsType.includes(
        ProductRoutes.videoGallery,
      );
    },
    isGKS: (state) => {
      return state.clientData.common.eventsType.includes(ProductRoutes.gks);
    },
    isBingo: (state) => {
      return state.clientData.common.eventsType.includes(ProductRoutes.bingo);
    },
    isMultiLang: (state) => {
      return state.clientData.common.langList.length > 1;
    },
    getDefaultLang: (state) => {
      return state.clientData.common.langList[0] ?? 'pl';
    },
    getDefaultType: (state) => {
      return state.clientData.common.defaultType ?? ProductRoutes.unknow;
    },
    getColors: (state) => {
      return state.colors;
    },
  },
});
